import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-box-wide__personalization-banner-wrapper"
}
const _hoisted_2 = ["innerHTML"]

import type ProductBoxData from '../../types/ProductBoxData';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import {ProductBoxWideSettings} from './productBoxWideSettings';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBoxWideSegmentHeader',
  props: {
    productBoxData: {},
    settings: {}
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_ctx.settings.personalisationTop && _ctx.productBoxData.personalPreferenceMessageKey)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "product-box-wide__personalization-banner personalization-banner",
          innerHTML: _unref(t)(_ctx.productBoxData.personalPreferenceMessageKey)
        }, null, 8 /* PROPS */, _hoisted_2)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})